<div class="dialog_container">
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 30px;">
        <h1 mat-dialog-title>Create space</h1>
    </div>
</div>